import { combineReducers } from 'redux'
import {
	externalFormSlice,
	orderBlackListSlice,
	businessappsSlice,
	blockSlice,
	unblockRequestStatusSlice,
	unBlockRequestSlice,
	recommendationsSlice,
	blockingRulesSlice,
	channelSlice,
	merchantBranchesSlice,
	blockProductSlice,
	productSlice,
	externalFormLandingsSlice,
} from 'Pages/orders'

export const reducers = combineReducers({
	[orderBlackListSlice.name]: orderBlackListSlice.reducer,
	[businessappsSlice.name]: businessappsSlice.reducer,
	[blockSlice.name]: blockSlice.reducer,
	[unBlockRequestSlice.name]: unBlockRequestSlice.reducer,
	[unblockRequestStatusSlice.name]: unblockRequestStatusSlice.reducer,
	[recommendationsSlice.name]: recommendationsSlice.reducer,
	[blockingRulesSlice.name]: blockingRulesSlice.reducer,
	[channelSlice.name]: channelSlice.reducer,
	[merchantBranchesSlice.name]: merchantBranchesSlice.reducer,
	[externalFormSlice.name]: externalFormSlice.reducer,
	[blockProductSlice.name]: blockProductSlice.reducer,
	[productSlice.name]: productSlice.reducer,
	[externalFormLandingsSlice.name]: externalFormLandingsSlice.reducer,
})
